import { AlertColor } from '@mui/material';
import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'alert',
  initialState: {
    visible: false,
    text: '',
    severity: 'success' as AlertColor,
  },
  reducers: {
    successAlert: (state, action) => {
      state.visible = true
      state.text = action.payload
      state.severity = 'success'
    },
    errorAlert: (state, action) => {
      state.visible = true
      state.text = action.payload
      state.severity = 'error'
    },
    hideAlert: state => {
      state.visible = false
    },
  }
})

export const { successAlert, errorAlert, hideAlert } = slice.actions;
export default slice.reducer;
